import React, { useState } from 'react';
import { Col, Card, Modal, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faUpload } from '@fortawesome/free-solid-svg-icons';
import useAuth from '../../../hooks/useAuth';
import { ref, uploadBytes } from 'firebase/storage';
import swal from 'sweetalert';;


const DashboardBannerImage = ({ banner }) => {

    const [modalShow, setModalShow] = useState(false);
    const [bannerUpload, setBannerUpload] = useState(null);
    const { storage } = useAuth();
    const [uploadPreview, setUploadPreview] = useState(null);
    const [uploading, setUploading] = useState(false)
    const [currentBanner, setCurrentBanner] = useState(banner.url);


    const handleUploadBanner = (id) => {
        if (bannerUpload == null) {
            return 0;
        }
        else {
            setUploading(true);
            const bannerRef = ref(storage, `banners/banner${banner.bannerID}`);
            uploadBytes(bannerRef, bannerUpload)
                .then(() => {
                    setCurrentBanner(uploadPreview);
                    setUploading(false);
                    setModalShow(false);
                    swal("Banner Replaced Successfully", "You can now see your new banner in the home page", "success");
                });
        }
    }


    const uploadOnChange = (event) => {
        setBannerUpload(event.target.files[0]);
        setUploadPreview(URL.createObjectURL(event.target.files[0]));
        setModalShow(true);
    }



    return (
        <Col>
            <Card className="rounded-3">
                <Card.Img variant="top" src={currentBanner} />
                <input id={`upload${banner.bannerID}`} type="file" className="form-control border-0 d-none"
                    onChange={uploadOnChange}
                />
                {
                    uploading
                        ?
                        <button className="btn btn-warning w-100 disabled d-flex align-items-center justify-content-center" style={{
                            borderRadius: 0
                        }}>
                            <span className="m-0">Loading</span>
                            <Spinner className="m-0 ms-2" animation="border" size="sm" />
                        </button>
                        :
                        <label className="btn btn-warning w-100" htmlFor={`upload${banner.bannerID}`} style={{
                            borderRadius: 0
                        }}>
                            Replace Banner <FontAwesomeIcon icon={faEdit} />
                        </label>


                }
            </Card>

            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Upload New Banner Image
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <img className="img-fluid" src={uploadPreview} alt="" />
                </Modal.Body>
                <Modal.Footer>
                    {
                        uploading
                            ?
                            <button className="btn btn-success w-100 disabled d-flex align-items-center justify-content-center">
                                <span className="m-0">Loading</span>
                                <Spinner className="m-0 ms-2" animation="border" size="sm" />
                            </button>
                            :
                            <button onClick={() => {
                                handleUploadBanner(banner.bannerID)
                            }} className="btn btn-success w-100">
                                Upload Banner <FontAwesomeIcon icon={faUpload} />
                            </button>
                    }
                </Modal.Footer>
            </Modal>
        </Col >
    );
};

export default DashboardBannerImage;